import { baseApi } from '../../../core/baseApi';
import {
  createGetArchivedQuery,
  createGetArchivedDetailsQuery,
  createRestoreMutation,
  createBulkRestoreMutation,
  createPermanentDeleteMutation,
  createBulkPermanentDeleteMutation
} from '../../../patterns/archive';
import { ConversationData } from '@/api/features/conversations';

export const archivedConversationsApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getArchivedConversations: createGetArchivedQuery<ConversationData>('/conversations/archived', 'ArchivedConversations')(builder),
    getArchivedConversationDetails: createGetArchivedDetailsQuery<ConversationData>('/conversations', 'ArchivedConversations')(builder),
    restoreArchivedConversation: createRestoreMutation('/conversations', 'Conversations', 'ArchivedConversations', true)(builder),
    bulkRestoreArchivedConversations: createBulkRestoreMutation('/conversations', 'Conversations', 'ArchivedConversations')(builder),
    permanentDeleteArchivedConversation: createPermanentDeleteMutation('/conversations', 'ArchivedConversations')(builder),
    bulkDeleteArchivedConversations: createBulkPermanentDeleteMutation('/conversations', 'ArchivedConversations')(builder)
  })
});

export const {
  useGetArchivedConversationsQuery,
  useGetArchivedConversationDetailsQuery,
  useRestoreArchivedConversationMutation,
  useBulkRestoreArchivedConversationsMutation,
  usePermanentDeleteArchivedConversationMutation,
  useBulkDeleteArchivedConversationsMutation
} = archivedConversationsApi;